module.exports = __webpack_public_path__ + "img/20250108220008.6f1f1275.jpg";